'use strict';

var Debug = require('../util/debug')('bitrate-util');

module.exports = (function () {
	const aspectRatio = 16 / 9;

	function _doesTheVideoFit(video, width, height) {
		return (width / height) > aspectRatio ? (width >= video.width) : (height >= video.height);
	}

    /**
     * Find the maximum bandwidth in an array of variant streams that can fit
     * inside the specified width and height.
     *
     * @param {Object[]} variants The variant streams to search in.
     * @param {Number} width Limiting width.
     * @param {Number} height Limiting height.
     * @return {Number} Returns the highest bitrate that the portal can fully
     *   utilize.
     */
    function findMaxFittingBandwidth(variants, width, height) {
        // Sort by bandwidth
        variants = variants.sort((a, b) => a.bandwidth - b.bandwidth);

        let i = 0;
        let match = variants[variants.length - 1];

        for (; i < variants.length; i++) {
            if (variants[i].height && !_doesTheVideoFit(variants[i], width, height)) {
                match = variants[i];
                break;
            }
        }
        while (i + 1 < variants.length) {
            if (variants[i + 1].height && match.height !== variants[i + 1].height) {
                match = variants[i];
                break;
            }
            i++;
        }

        Debug.log(`findMaxFittingBandwidth -
            stream: ${match.bandwidth} ${match.width}x${match.height}
            element: ${width}x${height}`);

        return match.bandwidth;
    }

    /**
     * Limit the given variant streams (representation) to only contain items
     * that fit the videoElement or screen. The algorithm perfers to scale
     * down before scaling up.
     *
     * @param {HTMLVideoElement} videoElement Video element to test for.
     * @param {Object[]} variants Array of available bitrates with
     *   corresponding width and height.
     * @param {boolean} useScreenAsMax Whether or not to use the screen size
     *   or video element size as limiting portal.
     * @return {Object[]} Returns a filtered array of variant streams.
     */
    function limitVariantStreamsByPortal(variants, videoElement, useScreenAsMax) {
        if (variants === undefined || variants.length === 0) {
            return variants;
        }

        const height = useScreenAsMax ? screen.height : parseInt(window.getComputedStyle(videoElement).height, 10);
        const width = useScreenAsMax ? screen.width : parseInt(window.getComputedStyle(videoElement).width, 10);

        const bitrateLimit = findMaxFittingBandwidth(variants, width, height);

        return limitVariantStreamsByMaxConstant(variants, bitrateLimit);
    }

    /**
     * Limit given variant streams by a specified constant.
     *
     * @param {Object[]} variants Array of variant streams.
     * @param {Number} bitrateLimit The max bitrate constant.
     * @return {Object[]} Returns a filtered array of variant streams.
     */
    function limitVariantStreamsByMaxConstant(variants, bitrateLimit) {
        return variants.filter((item) => item.bandwidth <= bitrateLimit);
    }

	return {
        limitVariantStreamsByPortal,
        limitVariantStreamsByMaxConstant
	};
})();



// WEBPACK FOOTER //
// ./src/js/modules/bitrateutil.js